/* eslint-disable react-hooks/exhaustive-deps */
import globalText from "../../../../../utils/globalText";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CommonLayout from "../../../../_utils/CommonLayout";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";
import DynamicAdditionalFields from "../../../../_utils/TransactionCommonComponents/DynamicAdditionalFields";

const ScheduleTransactionStepAdditionalDetails = ({
  txnPayLoad,
  beneAccountId,
  category,
  selectedCategory,
  unassignCategories,
  unassignlength,
  disableCategories,
  isCategoryLoading,
  isCategorySelected,
  handleCategorySelect,
  handleUnassignNavigate,
  additionalData,
  setAdditionalData,
  handleInputChange,
  hyperLink,
  setHyperLink,
  timeData,
  setTimeData,
  quantities,
  setQuantities,
  uploadedFiles,
  setUploadedFiles,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  selectedValue,
  setSelectedValue,
  selectedValueMonth,
  setSelectedValueMonth,
  initialRefactorAdditionalDetail,
  setInitialRefactorAdditionalDetail,
  previewImages,
  setPreviewImages,
  selectedLabelsCreate,
  setShowLabelModal,
}) => {
  return (
    <>
      <div
        className="max-w-tab-width-normal w-width-full mx-auto py-padding-md px-padding-md Qlg:px-padding-base"
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)] pb-padding-md">
            <CategorySelector
              beneAccountId={beneAccountId}
              category={category}
              selectedCategory={selectedCategory}
              unassignCategories={unassignCategories}
              unassignlength={unassignlength}
              disableCategories={disableCategories}
              handleCategorySelect={handleCategorySelect}
              handleUnassignNavigate={handleUnassignNavigate}
              previewMode={false}
              enableSearch
              showUnassignCTA={true}
            />
          </div>
          <div className="w-width-full lg:max-w-[var(--create-box-width)] pb-padding-md Qsmd:pb-padding-base flex flex-col gap-gap-md">
            <DynamicAdditionalFields
              headerText={globalTextFormat(
                globalText.CATEGORY_SPECIFIC_DETAILS,
                [0, 1, 2],
              )}
              mergeCategory={txnPayLoad?.mergeCategory}
              isCategoryLoading={isCategoryLoading}
              isCategorySelected={isCategorySelected}
              requiresCategorySelection={true}
              additionalData={additionalData}
              setAdditionalData={setAdditionalData}
              hyperLink={hyperLink}
              setHyperLink={setHyperLink}
              timeData={timeData}
              setTimeData={setTimeData}
              quantities={quantities}
              setQuantities={setQuantities}
              uploadedFiles={uploadedFiles}
              setUploadedFiles={setUploadedFiles}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              selectedValueMonth={selectedValueMonth}
              setSelectedValueMonth={setSelectedValueMonth}
              initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
              setInitialRefactorAdditionalDetail={
                setInitialRefactorAdditionalDetail
              }
              previewImages={previewImages}
              setPreviewImages={setPreviewImages}
              onInputChanged={(name, value, type) => {
                handleInputChange({
                  target: {
                    name,
                    value,
                    data_typeChan: type,
                  },
                });
              }}
            />
            <AssignLabels
              setLabelpopup={setShowLabelModal}
              labels={selectedLabelsCreate}
              subText1={globalText?.LABELS_USAGE_NOTE}
              subText2={globalText?.LABELS_AUTO_ASSIGNED_NOTE}
              isOptional={true}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default ScheduleTransactionStepAdditionalDetails;
